module.exports = __webpack_public_path__ + "img/particle_motion_00078.0234d613.png";